import type { OrderCommandStatus } from './operations'

/*
 * Типы команд обмена с 1С у ручек заказов. `CommandDto.type` в схеме — просто `string`, а
 * конкретные типы в OpenAPI не попадают: перечень известных ведём здесь руками.
 * `orders.merge`/`orders.split` 1С не исполняет — команда закроется по сроку (`expired`);
 * `orders.change-quantity`/`orders.remove-lines` 1С исполняет — их опрашивают до терминального
 * статуса (результат приходит и по WS §0: топики `commands:<userId>` и `orders:<unp>`).
 */
export const ORDER_COMMAND_TYPES = [
  'reserve.create',
  'invoice.append',
  'orders.change-quantity', // нет в схеме, 1С исполняет: правка количества отправленного own-счёта
  'orders.remove-lines', // нет в схеме, 1С исполняет: удаление строк отправленного own-документа
  'orders.merge', // нет в схеме: 1С не отвечает, команда истекает
  'orders.split', // нет в схеме: 1С не отвечает, команда истекает
] as const

export type OrderCommandType = (typeof ORDER_COMMAND_TYPES)[number]

/** Известный тип команды или `null`: поле `type` ответа — открытый `string`, сужаем по перечню. */
export function orderCommandTypeOf(type: string): OrderCommandType | null {
  return (ORDER_COMMAND_TYPES as readonly string[]).includes(type)
    ? (type as OrderCommandType)
    : null
}

/** Терминальные статусы: ответ 1С пришёл или срок вышел — опрос больше не нужен. */
const TERMINAL_STATUSES: readonly OrderCommandStatus[] = ['done', 'failed', 'expired']

export function isOrderCommandSettled(status: OrderCommandStatus | undefined): boolean {
  return status !== undefined && TERMINAL_STATUSES.includes(status)
}
